import { createSlice } from "@reduxjs/toolkit"

interface AppState {
  authState: string
  accessToken: string
  loading: boolean
  openSidebar: boolean
  isUserLoggedIn: boolean
  initializing: boolean
  isTermsChecked: boolean
  exportPdfCsvSelection: string
}

const initialState: AppState = {
  authState: "login",
  accessToken: "",
  loading: false,
  openSidebar: true,
  isUserLoggedIn: false,
  initializing: false,
  isTermsChecked: false,
  exportPdfCsvSelection: "PDF",
}

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setAuthState: (state, action) => {
      state.authState = action.payload
    },
    setAccessToken: (state, action) => {
      state.accessToken = action.payload
    },
    setLoading: (state, action) => {
      state.loading = action.payload
    },
    setOpenSidebar: (state, action) => {
      state.openSidebar = action.payload
    },
    setUserLogIn: (state, action) => {
      state.isUserLoggedIn = action.payload
    },
    setInitializing: (state, action) => {
      state.initializing = action.payload
    },
    setIsTermsChecked: (state, action) => {
      state.isTermsChecked = action.payload
    },
    setExportPdfCsvSelection: (state, action) => {
      state.exportPdfCsvSelection = action.payload
    },
  },
})

export default appSlice.reducer
export const {
  setAuthState,
  setAccessToken,
  setLoading,
  setOpenSidebar,
  setUserLogIn,
  setInitializing,
  setIsTermsChecked,
  setExportPdfCsvSelection,
} = appSlice.actions
